import { useRouteMatch } from 'react-router-dom';

export const useIsSelectingImages = () => {
    const isSelectingMusic = useRouteMatch(
        '/app/new-video/step1/personalmedia',
    );
    return isSelectingMusic ? true : false;
};

export const useIsImageSelection = () => {
    const isSelectingMusic = useRouteMatch('/app/new-video/step1');
    return isSelectingMusic ? true : false;
};

export const useIsImageUpload = () => {
    const isUploadingImages = useRouteMatch('/app/image-upload/');
    return isUploadingImages ? true : false;
};

export const useIsNewVideo = () => {
    const isUploadingImages = useRouteMatch('/app/new-video');
    return isUploadingImages ? true : false;
};
